import gql from "graphql-tag";

import type {GqlFetchFn} from "@repo/data-gql";
import {gqlOp, type GqlOperation} from "@repo/data-gql-core";
import {Errors, KAError} from "@repo/logging";

import type {Program} from "../scratchpad-ui.tsx";

import type {
    updateProgram as updateProgramResult,
    updateProgramVariables,
} from "./__graphql-types__/updateProgram.ts";
import {mapToProgram} from "./gql-type-mappers.ts";
import {PROGRAM_FRAGMENT} from "./program-fragment.ts";

export const UPDATE_PROGRAM: GqlOperation<
    updateProgramResult,
    updateProgramVariables
> = gqlOp(gql`
    mutation updateProgram(
        $programId: ID!
        $title: String
        $revision: ProgramRevisionInput!
    ) {
        updateProgram(
            programId: $programId
            title: $title
            revision: $revision
        ) {
            program {
                ...Program
            }
            error {
                code
                debugMessage
            }
        }
    }

    ${PROGRAM_FRAGMENT}
`);

export const updateProgram = async (
    gqlFetch: GqlFetchFn,
    variables: updateProgramVariables,
): Promise<Program> => {
    const result = await gqlFetch(UPDATE_PROGRAM, {variables});
    const program = result.updateProgram?.program;
    if (!program) {
        throw new KAError("Failed to update program", Errors.Internal);
    }
    return mapToProgram(program);
};
